import { unitOfMeasures } from "helpers/enums";
import { requiredField } from "helpers/validators";
import { namesList as counterpartiesList } from "sources/books/cargoOwners";
import { list as legalPersonsList } from "sources/books/legalPersons";

export const config = {
    counterpartyId: {
        label: "Контрагент",
        inputProps: { name: "counterpartyId" },
        url: counterpartiesList,
        propName: "name",
        menuPortalTarget: document.body,
        required: true,
        validators: [requiredField],
    },
    legalPersonId: {
        label: "Юрлицо",
        inputProps: { name: "legalPersonId" },
        url: legalPersonsList,
        propName: "name",
        menuPortalTarget: document.body,
    },
    date: {
        label: "Дата реестра",
        inputProps: { name: "date", type: "date" },
        inPortal: true,
        required: true,
        validators: [requiredField],
    },
    from: {
        label: "Период от",
        inputProps: { name: "from", type: "date" },
        inPortal: true,
        required: true,
        validators: [requiredField],
    },
    to: {
        label: "Период до",
        inputProps: { name: "to", type: "date" },
        inPortal: true,
        required: true,
        validators: [requiredField],
    },
    comment: {
        label: "Комментарий",
        inputProps: { name: "comment" },
        textarea: true,
    },
    items: {
        value: [],
        config: {
            id: {},
            relatedToId: {
                label: "ID заявки",
                type: "number",
                inputProps: { name: "relatedToId" },
            },
            contractUniversalDocumentId: {
                label: "ID договор-заявки",
                type: "number",
                inputProps: { name: "contractUniversalDocumentId" },
            },
            completedAt: {
                label: "Дата завершения",
                inputProps: { name: "completedAt", type: "date" },
                inPortal: true,
                required: true,
                validators: [requiredField],
            },
            quantity: {
                label: "Количество",
                type: "number",
                inputProps: { name: "quantity", min: 1 },
            },
            unitOfMeasure: {
                label: "Ед. изм.",
                inputProps: { name: "unitOfMeasure" },
                options: unitOfMeasures,
                menuPortalTarget: document.body,
                unClearable: true,
            },
            amount: {
                label: "Сумма с НДС",
                type: "number",
                inputProps: { name: "amount", step: "0.01", min: 0 },
                required: true,
                validators: [requiredField],
            },
            vatRate: {
                label: "Ставка НДС",
                type: "number",
                inputProps: { name: "vatRate", step: "0.01", min: 0 },
            },
            itemComment: {
                label: "Комментарий",
                inputProps: { name: "comment" },
                textarea: true,
            },
        },
    },
};
